/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

class TextInput extends React.PureComponent {
	static propTypes = {
		name: PropTypes.string.isRequired,
		label: PropTypes.string.isRequired,
		hasSubmitted: PropTypes.bool,
		isSubmitting: PropTypes.bool,
	};

	constructor(props) {
		super(props);

		const nextState = this._getState(props);
		nextState.areErrorsVisible = props.hasSubmitted;
		this.state = {
			...nextState,
		};
	}

	componentWillReceiveProps(nextProps) {
		const nextState = this._getState(nextProps);

		// check if we just started submitting
		// if we did, make errors visible again, if we have them
		if (!this.props.isSubmitting && nextProps.isSubmitting) {
			nextState.areErrorsVisible = true;
		}

		return this.setState(nextState);
	}

	_getState = (nextProps) => {
		return {
			isFocused: false,
			hasError: nextProps.error,
		};
	};

	_onFocus = (e) => {
		this.setState({ isFocused: true });
		return typeof this.props.onFocus === "function"
			? this.props.onFocus(e)
			: undefined;
	};

	_onBlur = (e) => {
		this.setState({ isFocused: false });
		return typeof this.props.onBlur === "function"
			? this.props.onBlur(e)
			: undefined;
	};

	_onChange = (e) => {
		// clear error on type
		this.setState({ hasError: false, areErrorsVisible: false });
		return typeof this.props.onChange === "function"
			? this.props.onChange(e)
			: undefined;
	};

	render() {
		let hasError;

		if (
			this.props.hasSubmitted &&
      this.state.hasError &&
      this.state.areErrorsVisible
		) {
			hasError = true;
		}

		const inputClasses = classnames({
			"okpay-input": true,
			"okpay-input--focused": this.state.isFocused,
		});

		const containerClasses = classnames({
			"okpay-input-container": true,
			"okpay-input-container--haserror": hasError,
		});

		const htmlFor = `okpay-${this.props.name.toLowerCase()}`;

		return (
			<label htmlFor={htmlFor} className={containerClasses}>
				<span className="okpay-input-label">{this.props.label}</span>
				<input
					name={this.props.name}
					value={this.props.value || ""}
					className={inputClasses}
					id={`okpay-${this.props.name.toLowerCase()}`}
					type="text"
					autoComplete={this.props.autoComplete || "off"}
					onFocus={this._onFocus}
					onBlur={this._onBlur}
					onChange={this._onChange}
				/>
			</label>
		);
	}
}

export default TextInput;



// WEBPACK FOOTER //
// ./src/reflux/okpay/util/TextInput.jsx